<mat-accordion class="management-accordion">
    <mat-expansion-panel expanded="true" hideToggle class="panel-form">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
            <div class="detail-header-container">
                <mat-panel-title (click)="$event.stopPropagation()">
                    <p class="title">Paramètres</p>
                </mat-panel-title>
            </div>
        </mat-expansion-panel-header>
        <div class="parameters-container">
            @if (_paramsContext) {
                <app-parameters-values-form
                    [disabled]="false"
                    [context]="_paramsContext"
                    [paramsValues]="_paramsContext.paramsValues"
                    [hierarchyValues]="_paramsContext.groupParentParamsValues"
                    (paramsValuesUpdated)="onParamsValuesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-parameters-values-form>
            }
        </div>
    </mat-expansion-panel>
</mat-accordion>
